function changethumbnail(){
  setTimeout(function(){
    var mediaId=$('.product-gallery--viewport--figure[data-product-gallery-selected="true"]').data('media');
    var slickId = $('.product-gallery--media-thumbnail[data-media="'+mediaId+'"]').data('slick-index');
    $('.product-gallery--navigation.slick-slider button.product-gallery--media-thumbnail').removeClass('c2-active')
    $('.product-gallery--media-thumbnail[data-media="'+mediaId+'"]').addClass('c2-active');
    $('.product-gallery--navigation').slick('slickGoTo',slickId);

  },300)
}

// $(document).on("click",".inline-field-wrapper .input-checkbox-wrapper",function() {
//   $('.input-checkbox-wrapper').addClass('c2-unavailable');
//   var current_option_selected = $(this).find('input').val();
//   var all_available_option = $('.product-select option').filter(function(option){
//     if($($('.product-select option')[option]).text().includes(current_option_selected)){
//         return $($('.product-select option')[option]);
//     }
//   });
//   // Finding Selected Index
//   var selected_index = 0;
//   var current_values = $(all_available_option[0]).text().trim().split(' - ')[0].split(' / ');
//   var is_available = $(all_available_option[0]).attr('disabled');
//   for(value in current_values){
//     if(current_values[value] == current_option_selected){
//       selected_index = value;
//       break;
//     }
//   }
    
//   for(var k = 0 ; k < all_available_option.length ; k++){
//     var current_values = $(all_available_option[k]).text().trim().split(' - ')[0].split(' / ');
//     var is_available = $(all_available_option[k]).attr('disabled');
//     var all_option_container = $('.product-options .inline-field-wrapper');
//     if(is_available != 'disabled'){
//       is_available = true;
//     }
    
//     if(is_available){
//       debugger
      
//       for(var index = 0 ; index < all_option_container.length ; index++){
//         if(index!=selected_index){
//           var selected_container_all_options=all_option_container[index].find('.input-checkbox-wrapper');
//           for(var index1 = 0 ; index1 < selected_container_all_options.length; index1++){
            
//           }
//         }
//       }
//       $($('.product-options .inline-field-wrapper')[1]).find('.input-checkbox').val()
//     }else{
//       debugger
//     }
    
//   }
// });


$(document).on("click",".inline-field-wrapper.product-option--first .input-checkbox-wrapper",function() {
  var current_option_selected = $(this).find('input').val();
  // for(var index = 0; index<$('.input-checkbox:checked').length;index++){
  //   current_option_selected
  // }
  findAvailableOption(current_option_selected);
    

});
findAvailableOption($($('.input-checkbox:checked')[0]).val());
function findAvailableOption(current_option_selected){
  var all_available_option = $('.product-select option').filter(function(option){
    if($($('.product-select option')[option]).text().includes(current_option_selected)){
        return $($('.product-select option')[option]);
    }
  });
  // Finding Selected Index

  var all_option_container = $('.product-options .inline-field-wrapper');
  for(var index = 1 ; index < all_option_container.length ; index++){
      var selected_container_all_options=$(all_option_container[index]).find('.input-checkbox-wrapper');
      for(var index1 = 0 ; index1 < selected_container_all_options.length; index1++){
        $(selected_container_all_options[index1]).addClass('c2-unavailable');
      }
  }
  
  for(var current_selected_index = (all_available_option.length-1); current_selected_index > -1 ; current_selected_index--){
    var current_values = $(all_available_option[current_selected_index]).text().trim().split(' - ')[0].split(' / ');
    var is_available = $(all_available_option[current_selected_index]).attr('disabled');
    
    for(var index2=(current_values.length-1); index2 > 0;index2--){
        if($(all_available_option[current_selected_index])){
          $('.input-checkbox[value="'+current_values[index2]+'"]').click();
        }
        if(is_available!='disabled'){
          $('.input-checkbox[value="'+current_values[index2]+'"]').parent().removeClass("c2-unavailable");
        }
      
    }
    
  }
}


$('.product-option--Color .input-checkbox-wrapper').on('click',function(){
  var checkbox_val = "."+$(this).find('input').val().replaceAll(' ','-');
  var material_val = $('.product-option--Material .input-checkbox:checked').val().replaceAll(' ','-');
  var final_val = checkbox_val+'--'+material_val;
  $('.product-gallery--navigation').slick('slickUnfilter');
  
  if($(final_val).length>0){
    
  }else{
    final_val = checkbox_val;
  }
  $('.product-gallery--navigation').slick('slickFilter', final_val);
  $('.product-gallery--navigation').slick('setPosition');
});

$('.product-option--Material .input-checkbox-wrapper').on('click',function(){
  var checkbox_val = "."+$('.product-option--Color  .input-checkbox:checked').val().replaceAll(' ','-');
  var material_val = $(this).find('input').val().replaceAll(' ','-');
  var final_val = checkbox_val+'--'+material_val;
  $('.product-gallery--navigation').slick('slickUnfilter');
  
  if($(final_val).length>0){
    
  }else{
    final_val = checkbox_val;
  }
  $('.product-gallery--navigation').slick('slickFilter', final_val);
  $('.product-gallery--navigation').slick('setPosition');
});